import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthAppGuard } from './guards/auth-app.guard';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthAppGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./components/dashboard/dashboard.module').then(module => module.DashboardModule),
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./components/admin/usuarios/usuarios.module').then(module => module.UsuariosModule),
      },
      {
        path: 'clientes',
        loadChildren: () => import('@modules/users/users.module').then(module => module.UsersModule),
      },
      {
        path: 'servicios',
        loadChildren: () => import('./components/admin/servicios/servicios.module').then(module => module.ServiciosModule),
      },
      {
        path: 'pagos',
        loadChildren: () => import('./components/admin/recibos/recibos.module').then(module => module.RecibosModule),
      },
      {
        path: 'pago',
        loadChildren: () => import('./modules/sales/payments/payments.module').then(module => module.PaymentsModule),
      },
      {
        path: 'recibos',
        loadChildren: () => import('./modules/sales/receipts/receipts.module').then(module => module.ReceiptsModule),
      },
      {
        path: 'dispositivos',
        loadChildren: () => import('./modules/network/devices/devices.module').then(module => module.DevicesModule),
      },
      {
        path: 'cliente',
        loadChildren: () => import('./components/cliente/cliente.module').then(module => module.ClienteModule),
      },
      {
        path: 'suspensiones',
        loadChildren: () => import('@modules/suspensions/suspensions.module').then(module => module.SuspensionsModule),
      },
      {
        path: 'sites',
        loadChildren: () => import('@modules/network/sites/sites.module').then(module => module.SitesModule),
      },
      {
        path: 'torres',
        loadChildren: () => import('@modules/network/towers/towers.module').then(module => module.TowersModule),
      },
      {
        path: 'olts',
        loadChildren: () => import('@modules/network/olts/olts.module').then(module => module.OltsModule),
      },
      {
        path: 'cajas-nap',
        loadChildren: () => import('@modules/network/nap-boxes/nap-boxes.module').then(module => module.NapBoxesModule),
      },
      {
        path: 'ipv4-block',
        loadChildren: () => import('@modules/network/ipv4/ipv4.module').then(module => module.Ipv4Module),
      },
      {
        path: 'notificationes',
        loadChildren: () => import('@modules/notifications/notifications.module').then(module => module.NotificationsModule),
      },
      {
        path: 'support',
        loadChildren: () => import('./modules/support/support.module').then(m => m.SupportModule)
      }
    ],
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'admin',
        loadChildren: () => import('./components/auth/auth.module').then(module => module.AuthModule),
      },
    ],
  },
  /*{
    path: '',
    component: GuestComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./demo/pages/authentication/authentication.module').then((module) => module.AuthenticationModule)
      },
      {
        path: 'maintenance',
        loadChildren: () => import('./demo/pages/maintenance/maintenance.module').then((module) => module.MaintenanceModule)
      }
    ]
  }*/
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
